const SIZES = {
  sm: { padding: "6px 12px", fontSize: 12, gap: 6, iconSize: 13 },
  md: { padding: "9px 16px", fontSize: 13, gap: 7, iconSize: 14 },
  lg: { padding: "12px 22px", fontSize: 14, gap: 8, iconSize: 16 },
};

const VARIANTS = {
  primary: { bg: "var(--ink)", color: "var(--paper-0)", border: "var(--ink)", hover: "#000" },
  accent:  { bg: "var(--accent)", color: "var(--paper-0)", border: "var(--accent)", hover: "var(--accent-2)" },
  ghost:   { bg: "transparent", color: "var(--ink)", border: "var(--line-2)", hover: "var(--paper-2)" },
  quiet:   { bg: "transparent", color: "var(--ink-2)", border: "transparent", hover: "var(--paper-2)" },
  dashed:  { bg: "transparent", color: "var(--ink-3)", border: "var(--line-2)", hover: "var(--paper-2)", dashed: true },
  danger:  { bg: "transparent", color: "var(--warn)", border: "var(--warn-line)", hover: "var(--warn-soft)" },
};

export default function Btn({ children, onClick, variant = "ghost", size = "md", icon: Icon, disabled, style, title, type = "button" }) {
  const s = SIZES[size];
  const v = VARIANTS[variant];
  return (
    <button
      type={type}
      title={title}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = v.hover; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = v.bg; }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: s.gap,
        padding: s.padding,
        borderRadius: 8,
        border: `1px ${v.dashed ? "dashed" : "solid"} ${v.border === "transparent" ? "transparent" : v.border}`,
        background: v.bg,
        color: v.color,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        fontSize: s.fontSize,
        fontWeight: 500,
        letterSpacing: 0.1,
        fontFamily: "var(--ui)",
        transition: "background 0.12s",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {Icon && <Icon size={s.iconSize} stroke="currentColor" />}
      {children}
    </button>
  );
}
